<template>
    <div class="form-group">
        <label>{{ label }}</label>
        <select class="form-control" @input="inputEvent" v-model="selectedOption">
            <option v-if="allowNull" :value="null">-- Select --</option>>
            <option v-for="(option, name) in options" :value="option">{{ name }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        value: null,
        options: { type: Object, required: true },
        label: { type: String, required: true },
        allowNull: { type: Boolean, default: false }
    },
    data() {
        return {
            selectedOption: null
        }
    },
    methods: {
        inputEvent(event) {
            let value = event.target.value || null;
            this.$emit('input', value);
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function(newValue) {
                this.selectedOption = newValue;
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/primitives/Dropdown.vue